import { render, staticRenderFns } from "./FreeNfcIcon.vue?vue&type=template&id=0307e223"
import script from "./FreeNfcIcon.vue?vue&type=script&lang=js"
export * from "./FreeNfcIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports